import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "stock/expedition-order"

class service {

    getTotalsById(expeditionId) {

        return http.list(path + "/getTotals/"+expeditionId);
    }

    reverse(id) {
        return http.get(path + "/reverse-finish/" + id)
    }


}

export default new service();


